var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamCardCurve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 29,
    viewBox: "0 0 143 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9187 23.4106C16.9732 14.6117 12.5213 6.54731 1 1H142.5C130.183 9.06997 126.312 15.3041 118.634 23.4614C115.82 26.4512 111.835 28 107.729 28H71.75H35.7709C31.6649 28 27.6705 26.458 24.9187 23.4106Z",
    fill: "#5C5F62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1C12.5213 6.54731 16.9732 14.6117 24.9187 23.4106C27.6705 26.458 31.6649 28 35.7709 28H71.75H107.729C111.835 28 115.82 26.4512 118.634 23.4614C126.312 15.3041 130.183 9.06997 142.5 1",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamCardCurve);
export default __webpack_public_path__ + "static/media/team-card-curve.943fae8e33332569a76c2ce3b6a95be5.svg";
export { ForwardRef as ReactComponent };